export var SUBMIT_KEY = 'Enter';
export var ESCAPE_KEY = 'Escape';
export var META_KEY = 'Meta';
export var CTRL_KEY = 'Control';
export var SHIFT_KEY = 'Shift';
export var PATCH_MODAL_WIDTH = 300;
export var PATCH_MODAL_HEIGHT = 450;
export var INIT_PORT_LIMIT = 2;
export var RECONCILIATION_SELECTOR;
(function (RECONCILIATION_SELECTOR) {
    RECONCILIATION_SELECTOR["PATCH"] = "patches";
    RECONCILIATION_SELECTOR["EDGE"] = "edges";
})(RECONCILIATION_SELECTOR || (RECONCILIATION_SELECTOR = {}));
export var UI_EVENTS = {
    KEY_DOWN: 'keydown',
    KEY_UP: 'keyup',
    CLICK: 'click',
    CONTEXT_MENU: 'contextmenu',
};
export var PERMISSIONS = {
    CREATE: 'create',
    READ: 'read',
    UPDATE: 'update',
    DELETE: 'delete',
    PERMISSION: 'permission',
};
export var ACTION_PERMISSIONS = [
    PERMISSIONS.CREATE,
    PERMISSIONS.DELETE,
    PERMISSIONS.UPDATE,
];
export var EDGE_COLORS = {
    ROOT: 'root',
    BLANK: 'blank',
    LOGIC: 'logic',
    LOGIC_GROUP: 'logic_group',
    WARNING: 'warning',
    DEFAULT: 'default',
};
export var PATCH_TYPES = {
    VIEW: 'view',
    LIST: 'list',
    LOGIC: 'logic',
    LOGIC_GROUP: 'logic_group',
    NAVIGATION: 'navigation',
    DATASET: 'dataset',
};
export var NAVIGATION_TYPES = {
    GRID: 'grid',
    DRAWER: 'drawer',
    SUB_MENU: 'submenu',
    TAB: 'tab',
    DROPDOWN: 'dropdown',
};
export var PATCH_SECONDARY_TYPES = {
    INTEGRATION: 'integration',
    FROM_DATASET: 'from_dataset',
    CUSTOM_LOGIC: 'custom_logic',
    ASYNC_LOGIC: 'async_logic',
};
export var VIEW_PATCHES = [PATCH_TYPES.VIEW, PATCH_TYPES.LIST];
export var LOGIC_PATCHES = [
    PATCH_TYPES.LOGIC,
    PATCH_TYPES.LOGIC_GROUP,
    PATCH_SECONDARY_TYPES.CUSTOM_LOGIC,
];
export var PATCHES_WITH_REDIRECTION = [
    PATCH_TYPES.VIEW,
    PATCH_TYPES.LIST,
    PATCH_TYPES.LOGIC_GROUP,
    PATCH_SECONDARY_TYPES.CUSTOM_LOGIC,
];
